import { useMemo } from "preact/hooks";
import type { RoutableProps } from "preact-router";
import { LegalFooter } from "../components/footer";
import { PromoterInviteCard } from "../components/promoterInviteCard";
import { STRINGS } from "../constants/strings";

const STARS = [1, 2, 3, 4, 5];

export function ThankYouScreen(_props: RoutableProps) {
  const params = useMemo(
    () => new URLSearchParams(window.location.search),
    []
  );
  const firstName = params.get("name") ?? "";
  const companyName = params.get("company") ?? "";
  const ratingParam = params.get("rating");
  const rating = ratingParam ? Math.max(0, Math.min(5, parseInt(ratingParam, 10) || 0)) : 0;

  const onPromoterCta = () => {};

  return (
    <div class="tl-page">
      <div class="tl-page-centered" style="padding: 64px var(--tl-page-pad-x) 48px;">
        <div class="tl-icon-circle tl-icon-circle--lg">
          <span class="material-icons" aria-hidden="true">
            check_circle
          </span>
        </div>
        <h1 class="tl-screen-title tl-screen-title--xl">
          {STRINGS.thanksTitle(firstName)}
        </h1>
        <p class="tl-screen-body">{STRINGS.thanksBody}</p>
        {rating > 0 && (
          <div class="tl-thanks-rating">
            {STARS.map((idx) => (
              <span key={idx} class="material-icons" aria-hidden="true">
                {idx <= rating ? "star" : "star_border"}
              </span>
            ))}
            <span>{STRINGS.thanksJustNow}</span>
          </div>
        )}
      </div>
      <PromoterInviteCard
        companyName={companyName || "uns"}
        onCta={onPromoterCta}
      />
      <LegalFooter />
    </div>
  );
}
